import { render, staticRenderFns } from "./add_address.vue?vue&type=template&id=62d5a81f&scoped=true"
import script from "./add_address.vue?vue&type=script&lang=js"
export * from "./add_address.vue?vue&type=script&lang=js"
import style0 from "./add_address.vue?vue&type=style&index=0&id=62d5a81f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d5a81f",
  null
  
)

export default component.exports